import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { Button } from '../Button';
import { useInduction } from "../../hooks/useInduction";
import { CNPJ_PATTERN, normalizeCnpj } from "../../util/pattern";
import { Container, Form } from "./styles";
import { MyModal } from "../Modal";
import { IShowLGPDModal } from "../../TypesOrInterfaces/induction";
import { LgpdInformation } from "../LgpdInformation";

interface IFormInput {
    storeCnpj: string;
}

export function Store() {

    const { register, handleSubmit, errors } = useForm();

    const { getStore, isActiveLoader, showLGPDModal, setShowLGPDModal, showHeaderFooter } = useInduction();

    useEffect(() => {
        Object.values(errors).forEach(e =>
            toast.error(e.message)
        );

    }, [errors]);

    async function handleGetStore(data: IFormInput) {
        const cnpjStore = normalizeCnpj(data.storeCnpj);
        await getStore(cnpjStore);
    }

    const handleCloseModal = () => {
        setShowLGPDModal({benefit: '', open: false});
    }

    if(showHeaderFooter){
        return (
            <Container>
                     <Form onSubmit={handleSubmit(handleGetStore)} >
                          <input                                         
                              type="text"
                              placeholder="CNPJ"
                              name="storeCnpj"
                              ref={register({
                                  required: {
                                      value: true,
                                      message: 'Para efetuar a pesquisa insira um CNPJ'
                                  }
                                  ,
                                  pattern: CNPJ_PATTERN('CNPJ')
                              })}
                          />
      
                          <Button type="submit" isActive={isActiveLoader}>
                              Acessar
                          </Button>
                      </Form>
            <MyModal 
                show={showLGPDModal.open} 
                content={<LgpdInformation benefitName={showLGPDModal.benefit} />}
                onClose={handleCloseModal} 
                onCloseX={handleCloseModal}
            />
            </Container>
        )
    }
    else{
        return (
            <Container>
                     <Form onSubmit={handleSubmit(handleGetStore)} >
                          <>

                          Cadastro efetuado com sucesso!
                          
                          </>
                      </Form>

                      <Form onSubmit={handleSubmit(handleGetStore)} >
                          <>

                          Por favor, feche o pop-up.

                          </>
                      </Form>
            </Container>
        )
    }
}
